<template>
  <div class="item-inner" @click="onClick" :class="currentIndex === index ? 'selected' : ''">
    <span class="index">{{ index + 1 }}</span>
    <span class="name" v-clampy="1">{{ source[name] }}</span>
  </div>
</template>

<script>
import dispatch from './dispatch'

export default {
  name: 'LeftSiderItem',
  props: {
    source: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      dispatch(this, 'LeftSider', 'onClick', this.source, this.index)
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-inner {
  width: 100%;
  margin-top: 20px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;

  .index {
    margin-right: 10px;
  }

  .name {
    margin-left: 10px;
    user-select: none;
  }
}

.selected {
  color: #1890ff;
}
</style>
